module.exports = __webpack_public_path__ + "img/user-delete.836dffaf.svg";